import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./Loader.scss";
import { images } from "@/utils/constants";
export const Loader = ({ show }) => {
    return (_jsx("div", { className: show ? "overlay-loader" : "hide-loader", children: _jsx("div", { className: "loader-compound", children: _jsxs("div", { className: "loader", children: [_jsx("img", { src: images.LogoLoading, alt: "Flormorado Caf\u00E9 animaci\u00F3n de carga" }), _jsx("div", { className: "text-loader", children: "La vida es corta, bebe un buen caf\u00E9..." })] }) }) }));
};
